import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';

import { profileTaskTranslationKeys } from '../profile-task-translations';

export const DraftTaskUnavailable: FunctionComponent<{ readonly onClose: () => void }> = ({ onClose }) => {
    const translate = useTranslate();

    return (
        <div className="flex flex-col items-start gap-m" data-testid="profile-task-draft-unavailable">
            <h2 className="m-0 text-h4 font-medium text-text-primary">
                {translate(profileTaskTranslationKeys.draftUnavailableTitle)}
            </h2>
            <p className="m-0 text-sm leading-relaxed text-text-secondary">
                {translate(profileTaskTranslationKeys.draftUnavailableBody)}
            </p>
            <Button variant="secondary" onClick={onClose}>
                {translate('common.close')}
            </Button>
        </div>
    );
};
